import { IOrderParams } from '../../../../../API/pcDashboard/getOrderAsync';
import React, { useCallback, useEffect, useState } from 'react';

export interface TaskPaginationSortParams {
  page?: number;
  size: number | null;
  sort?: 'asc' | 'desc' | null;
  sortProperty?: string | null;
}

const defaultPaginationSortParams: TaskPaginationSortParams = {
  page: 0,
  size: 20,
  sort: 'desc',
  sortProperty: 'dueDate',
};

/**
 * Hook that manages the state of the tasks table's pagination and sort settings.
 * When the queryWithoutPagination prop changes, it resets the paginationSortParams back to the default.
 * @param queryWithoutPagination - the properties of the query that do not include pagination, sort, or sortProperty
 */
export const useManageTaskPagination = (
  queryWithoutPagination: Omit<IOrderParams, 'pageNumber' | 'pageSize' | 'sortBy'>
): {
  paginationState: [TaskPaginationSortParams, React.Dispatch<React.SetStateAction<TaskPaginationSortParams>>];
  revertToFirstPage: () => void;
} => {
  const [paginationSortParams, setPaginationSortParams] =
    useState<TaskPaginationSortParams>(defaultPaginationSortParams);
  useEffect(() => {
    setPaginationSortParams(defaultPaginationSortParams);
  }, [queryWithoutPagination]);
  const revertToFirstPage = useCallback(() => {
    setPaginationSortParams(defaultPaginationSortParams);
  }, []);

  return { paginationState: [paginationSortParams, setPaginationSortParams], revertToFirstPage };
};
